import React from 'react';
import ReactDOM from 'react-dom/client';
import { App, ConfirmationModalProvider } from './components';
import { Provider } from 'react-redux';
import { injectStore } from './api';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import './styles/fonts.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import { theme } from './styles/constants';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

injectStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <ConfirmationModalProvider>
            <DndProvider backend={HTML5Backend}>
              <App />
            </DndProvider>
          </ConfirmationModalProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
